export default "__VITE_ASSET__CIDXLAo9__"